function reCaptcha() {
  const watchRecaptcha = () => {
    let $io = new IntersectionObserver(
      function (entries) {
        if (
          entries[0].isIntersecting &&
          !document.querySelector(
            'script[src="https://www.google.com/recaptcha/api.js"]',
          )
        ) {
          let recaptchaScript = document.createElement('script');
          recaptchaScript.src = 'https://www.google.com/recaptcha/api.js';
          recaptchaScript.defer = true;
          document.body.appendChild(recaptchaScript);
        }
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 1.0,
      },
    );
    $io.observe(document.querySelector('.g-recaptcha'));
  };

  const init = () => {
    if (document.querySelector('.g-recaptcha')) {
      watchRecaptcha();
    }
  };

  init();
}
export default reCaptcha;
